export default {
    OC: 3,
    DDT: 6,
    DDT_TRANSFER: -6,
    OF: 4,
    WAREHOUSE: 8
}